<template>
  <div v-if="customerOverview">
    <v-layout justify-space-between>
      <p class="text-h5 mb-0">
        {{ customerOverview.Name + " " + customerOverview.Number }}
      </p>
      <v-btn @click="setDialog()" depressed color="primary" fab class="ml-4 text-right">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-layout>
    <!-- v-show="editTicket.Comment && showTicketComment" -->
    <v-layout align-center fill-height justify-space-between>
      <p class="mt-2 mb-1 text-h6">{{ $t("Bulletin board") }}</p>
      <v-switch
        flat
        :ripple="false"
        v-model="editorModeClient"
        color="primary"
        :label="$t('Edit')"
      ></v-switch>
    </v-layout>
    <v-row no-gutters v-if="editorModeClient">
      <v-col cols="12">
        <editor
          api-key="f18i0ywzo341k9tx3r3vjsnoghnomdrqbhx2qqi5lnul1dbh"
          v-model="customerOverview.BulletinBoard"
          :id="customerOverview.Id"
          :key="customerOverview.Id"
          :init="{
            height: 200,
            menubar: false,
            language: editorLanguage,
            plugins: [
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic underline strikethrough | link image | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat',
          }"
        />
      </v-col>
      <v-col cols="12" class="mt-2">
        <v-layout justify-end>
          <v-btn depressed small class="mr-2" @click="editorModeClient = false">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn depressed small :disabled="notChangedDisable">
            {{ $t("Save") }} <v-icon right> mdi-content-save</v-icon>
          </v-btn>
        </v-layout>
      </v-col>
    </v-row>
    <div
      v-else-if="!editorModeClient && customerOverview.BulletinBoard"
      v-html="customerOverview.BulletinBoard"
    ></div>
    <p v-else class="mb-0">
      {{ $t("The bulletin board is currently empty.") }}
    </p>
    <p class="mt-8 mb-1 text-h6">{{ $t("Open tickets") }}</p>

    <v-simple-table v-if="customerOverview" :height="250" fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              class="text-left"
              v-for="(header, index) in headers"
              :key="index"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in lastOpenTickets" :key="index">
            <td>{{ item.Key }}</td>
            <td>{{ item.Title }}</td>
            <td>{{ getAssignee() }}</td>
            <td>{{ getPriorties() }}</td>
            <td>
              <v-chip small :color="getStatusColor()">
                {{ getStatus() }}
              </v-chip>
            </td>
            <td>{{ readebleTime(item.StartDate, false) }}</td>
            <td>{{ readebleTime(item.ReadyDate, false) }}</td>
            <td>
              <v-icon color="warning" :ref="'editItemBtn' + item.Id">
                mdi-pencil
              </v-icon>
              <!-- <v-icon color="error" @click="openDeleteItemDialog(item)">
                mdi-delete
              </v-icon> -->
            </td>
          </tr>
          <tr>
            <td colspan="8">
              <v-layout justify-center align-center fill-height>
                <v-btn
                  class="my-4"
                  small
                  depressed
                  :disabled="getDisableOnGoing"
                  @click="
                    loadMore(
                      startCoutnerOnGoing,
                      counterOnGoing,
                      'startCoutnerOnGoing',
                      'LastOpenTickets'
                    )
                  "
                >
                  {{ $t("Load More") }}
                </v-btn>
              </v-layout>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <p v-else-if="!loadingFilter && !customerOverview">
      {{ $t("No data available") }}
    </p>
    <preloader v-else></preloader>

    <p class="mt-8 mb-1 text-h6">{{ $t("Closed tickets") }}</p>

    <v-simple-table v-if="customerOverview" :height="250" fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              class="text-left"
              v-for="(header, index) in headers"
              :key="index"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in lastClosedTickets" :key="index">
            <td>{{ item.Key }}</td>
            <td>{{ item.Title }}</td>
            <td>{{ getAssignee() }}</td>
            <td>{{ getPriorties() }}</td>
            <td>
              <v-chip small :color="getStatusColor()">
                {{ getStatus() }}
              </v-chip>
            </td>
            <td>{{ readebleTime(item.StartDate, false) }}</td>
            <td>{{ readebleTime(item.ReadyDate, false) }}</td>
            <td>
              <v-icon
                class="mr-2"
                color="warning"
                @click="editItem()"
                :ref="'editItemBtn' + item.Id"
              >
                mdi-pencil
              </v-icon>
              <v-icon color="error" @click="openDeleteItemDialog(item)">
                mdi-delete
              </v-icon>
            </td>
          </tr>
          <tr>
            <td colspan="8">
              <v-layout justify-center align-center fill-height>
                <v-btn
                  class="my-4"
                  small
                  :disabled="getDisableClosed"
                  @click="
                    loadMore(
                      startCoutnerClosedTickets,
                      counterClosedTickets,
                      'startCoutnerClosedTickets',
                      'LastClosedTickets'
                    )
                  "
                >
                  {{ $t("Load More") }}
                </v-btn>
              </v-layout>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <p v-else-if="!loadingFilter && !customerOverview">
      {{ $t("No data available") }}
    </p>
    <preloader v-else></preloader>

    <newTicketDialog
      ref="newTicketDialog"
      :newTicket="newTicket"
      :pagingForFilter="null"
      :priorties="priorties"
      :statusses="statusses"
      :user="user"
      :trackers="trackers"
      @resetNewTicket="resetNewTicket"
    />
    <!--  
   
    <deleteTicketDialog
      ref="ticketDelete"
      :deleteTicket="deleteTicket"
      :pagingForFilter="null"
      @getOverview="getOverview"
    />
    <editTicketDialog
      ref="editTicketDialog"
      :editTicket="editTicket"
      :statusses="statusses"
      :priorties="priorties"
      :assignees="assignees"
      :trackers="trackers"
      :user="user"
      :editTicketFiles="editTicketFiles"
      :pagingForFilter="null"
    /> -->
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import auth from "../../auth";
import helpers from "../../helpers";
import newTicketDialog from "../shared/dialogs/NewTicketDialog.vue";
export default {
  data() {
    return {
      model: [],
      assignees: null,
      trackers: null,
      statusses: null,
      priorties: null,
      loadingFilter: null,
      newTicket: {
        Title: null,
        Description: null,
        AuthorId: null,
        AssigneeId: null,
        ReporterId: null,
        UserId: null,
        PriorityId: null,
        StatusId: null,
        TrackerIds: null,
        StartDate: null,
        ReadyDate: null,
      },
      editorModeClient: false,
      loadingTickets: null,
      customerOverview: null,
      allTickets: [],
      bulletinBoardOld: null,
      startCoutnerClosedTickets: 0,
      counterClosedTickets: 10,
      startCoutnerOnGoing: 0,
      counterOnGoing: 10,
      itemCounterOpen: 0,
      itemCounterClosed: 0,
      btnOnGoing: false,
      editTicket: {
        TicketHistory: null,
      },
      user: auth.getUser(),
      ticketDelete: false,
      deleteTicket: false,
      editTicketFiles: null,
      colorAndStatus: [
        {
          color: "yellow",
          status: "te doen",
        },
        {
          color: "green",
          status: "bezig",
        },
      ],
    };
  },
  components: { editor: Editor, newTicketDialog },
  created() {
    this.customerOverview = {
      Id: "1",
      Name: "Streamliners",
      Number: "123-45",
      BulletinBoard: "",
      LastOpenTickets: [
        {
          Id: "634e73c05a099219be41575a",
          Number: 1503,
          Title: "RE: Demo ticket (Hotfix)",
          OriginalTitle: "RE: Demo ticket (Hotfix)",
          Files: [],
          Created: "2022-10-18T11:36:26+02:00",
          CreatedDate: "2022-10-18T02:00:00+02:00",
          Modified: "2022-10-18T11:36:26+02:00",
          StartDate: "2022-10-18T02:00:00+02:00",
          ReadyDate: "2022-10-18T02:00:00+02:00",
          ModifiedByUserId: null,
          AuthorId: "6320c957207ab74417d01779",
          AssigneeId: null,
          AssigneeName: null,
          ReporterId: "6320c957207ab74417d01779",
          CustomerId: "6320c907207ab74417d00540",
          CustomerName: "Baeten Bv",
          UserId: "6320c957207ab74417d01779",
          PriorityId: "62b3050f2702f6040df09435",
          StatusId: "62ac36844a70d58839d7fac9",
          TrackerIds: [],
          Key: "ST-123",
        },
        {
          Id: "634e5727596b2b506c8c6fb1",
          Number: 1490,
          Title: "RE: Nieuwe versie (Hotfix)",
          OriginalTitle: "RE: Nieuwe versie (Hotfix)",
          Files: [],
          Created: "2022-10-18T09:32:49+02:00",
          CreatedDate: "2022-10-18T02:00:00+02:00",
          Modified: "2022-10-18T09:32:49+02:00",
          StartDate: "2022-10-18T02:00:00+02:00",
          ReadyDate: "2022-10-18T02:00:00+02:00",
          ModifiedByUserId: null,
          AuthorId: "6320c957207ab74417d01779",
          AssigneeId: null,
          AssigneeName: null,
          ReporterId: "6320c957207ab74417d01779",
          CustomerId: "6320c907207ab74417d00540",
          CustomerName: "Baeten Bv",
          UserId: "6320c957207ab74417d01779",
          PriorityId: "62b3050f2702f6040df09435",
          StatusId: "62ac36844a70d58839d7fac9",
          TrackerIds: [],
          Key: "ST-124",
        },
        {
          Id: "6347cea82d3f2374eca2944c",
          Number: 1329,
          Title: "RE: Afspraak ",
          OriginalTitle: "RE: Afspraak",
          Files: [],
          Created: "2022-10-13T10:37:54+02:00",
          CreatedDate: "2022-10-13T02:00:00+02:00",
          Modified: "2022-10-13T10:37:54+02:00",
          StartDate: "2022-10-13T02:00:00+02:00",
          ReadyDate: "2022-10-13T02:00:00+02:00",
          ModifiedByUserId: null,
          AuthorId: "6320c957207ab74417d0176f",
          AssigneeId: null,
          AssigneeName: null,
          ReporterId: "6320c957207ab74417d0176f",
          CustomerId: "6320c907207ab74417d00540",
          CustomerName: "Baeten Bv",
          UserId: "6320c957207ab74417d0176f",
          PriorityId: "62b3050f2702f6040df09435",
          StatusId: "62ac36844a70d58839d7fac9",
          TrackerIds: [],
          Key: "ST-125",
        },
      ],
      LastOpenTicketsCount: 3,
      LastClosedTickets: [],
      LastClosedTicketsCount: 0,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("Ticket number"),
          align: "start",
          sortable: false,
          value: "Key",
        },

        {
          text: this.$t("Title ticket"),
          value: "Title",
        },
        { text: this.$t("Assignee"), value: "AssigneeId" },
        { text: this.$t("Priority"), value: "PriorityId" },
        { text: this.$t("Status"), value: "StatusId" },
        { text: this.$t("Start date"), value: "StartDate" },
        { text: this.$t("Ready date"), value: "ReadyDate" },
        { text: this.$t("Detail"), value: "actions" },
      ];
    },
    notChangedDisable() {
      if (this.bulletinBoardOld != this.customerOverview["BulletinBoard"]) {
        return false;
      }
      return true;
    },
    editorLanguage: {
      get: function () {
        if (!this.$i18n.locale()) {
          return "nl";
        }
        return this.$i18n.locale() == "Nl" ? "nl" : "fr_FR";
      },
    },
    lastClosedTickets() {
      if (this.loadingTickets) {
        return [];
      }
      return this.customerOverview.LastClosedTickets;
    },
    lastOpenTickets() {
      if (this.loadingTickets) {
        return [];
      }
      return this.customerOverview.LastOpenTickets;
    },
    getDisableOnGoing() {
      if (
        this.customerOverview.LastOpenTickets.length >= this.itemCounterOpen &&
        !this.btnOnGoing
      ) {
        return true;
      }
      return false;
    },
    getDisableClosed() {
      if (
        this.customerOverview.LastClosedTickets.length >= this.itemCounterClosed
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },

    getAssignee() {
      const names = ["Jan A.", "Wim M.", "Aiko VR.", "Jan W.", "Wim B."];
      return names[this.getRandomInt(names.length)];
    },
    getPriorties() {
      const prioritys = [
        "prioriteit 1",
        "prioriteit 2",
        "prioriteit 3",
        "prioriteit 4",
      ];

      return prioritys[this.getRandomInt(prioritys.length)];
    },
    getStatusColor() {
      return this.colorAndStatus[this.getRandomInt(this.colorAndStatus.length)]
        .color;
    },
    getStatus() {
      return this.colorAndStatus[this.getRandomInt(this.colorAndStatus.length)]
        .status;
    },
    resetNewTicket() {
      this.newTicket = {
        Title: null,
        Description: null,
        AuthorId: null,
        AssigneeId: null,
        ReporterId: null,
        UserId: null,
        PriorityId: null,
        StatusId: null,
        TrackerIds: null,
        StartDate: null,
        ReadyDate: null,
      };
    },
    setDialog() {
      this.newTicket.UserId = "";
      const date = new Date();
      this.newTicket.StartDate = date;
      this.newTicket.ReadyDate = date;
      this.$refs.newTicketDialog.setTicketDialog(true);
    },
    readebleTime(item, needsHM = true) {
      return helpers.changeTimeToReadeble(item, needsHM);
    },

    editItem() {},
  },
};
</script>

<style>
</style>